/* Italian labels + UI options for the Receivables (Incassi) module. */

export const arStatusIT = {
  due: "In attesa",
  partially_collected: "Parziale",
  collected: "Incassato",
  defaulted: "Insoluto",
  cancelled: "Annullato",
  not_due: "Non dovuto",
};

export const arRecurrenceIT = {
  one_time: "Una tantum",
  monthly: "Mensile",
  bi_monthly: "Bimestrale",
  quarterly: "Trimestrale",
  every_4_months: "Quadrimestrale",
  semi_annual: "Semestrale",
  annual: "Annuale",
};

export const arMethodIT = {
  bank_transfer: "Bonifico",
  cash: "Contanti",
  card: "POS",
  sdd: "RID/SDD",
  other: "Altro",
  unspecified: "Non specificato",
};

export const arMethodOptions = [
  { value: "bank_transfer", label: "Bonifico" },
  { value: "cash", label: "Contanti" },
  { value: "card", label: "POS" },
  { value: "sdd", label: "RID/SDD" },
  { value: "other", label: "Altro" },
];

export const arRecurrenceOptions = [
  "one_time",
  "monthly",
  "bi_monthly",
  "quarterly",
  "every_4_months",
  "semi_annual",
  "annual",
];
